export const SENDER_TYPE = {
  assistant: 'assistant',
  user: 'user'
};
